module.exports = __webpack_public_path__ + "img/ppt-addin-04.86d35092.png";